import { render } from "./subjectFusionInfo.vue?vue&type=template&id=f1bef852&scoped=true"
import script from "./subjectFusionInfo.vue?vue&type=script&lang=js"
export * from "./subjectFusionInfo.vue?vue&type=script&lang=js"

import "./subjectFusionInfo.vue?vue&type=style&index=0&id=f1bef852&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1bef852"]])

export default __exports__